module.exports = __webpack_public_path__ + "static/media/team-member-4.abf7dd9b.png";